module.exports = __webpack_public_path__ + "static/media/congrats.4fbb1aff.png";